import { useEffect, useState } from "react";
import { pad2 } from "./date-utils";
import { pluralize } from "./text-utils";

const getDiff = (date) => {
  const now = new Date();
  const secs = Math.round((now.getTime() - date.getTime()) / 10000) * 10;
  let days = null;
  if (secs < 2 * 24 * 3600 && secs > -2 * 24 * 3600) {
    if (now.getDate() === date.getDate()) {
      days = 0;
    } else {
      if (now > date) {
        const yesterday = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate() - 1,
        );
        if (yesterday.getDate() === date.getDate()) days = 1;
      } else {
        const tomorrow = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate() + 1,
        );
        if (tomorrow.getDate() === date.getDate()) days = -1;
      }
    }
  }

  return {
    secs,
    days,
    sameYear: now.getFullYear() === date.getFullYear(),
  };
};

const getNextTickSecs = (secs) => {
  if (secs < -3600) return 3600;
  const absSecs = Math.abs(secs);
  if (absSecs < 60) return 10;
  if (absSecs < 3600) return 60;
  if (absSecs < 2 * 24 * 3600) return 3600;
  return null;
};

const getTime = (date) => `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;

const dayToString = { "-1": "morgen", 0: "heute", 1: "gestern" };
const getLabel = (diff, date) => {
  if (diff.secs === 0) {
    return "jetzt";
  } else if (diff.secs > 0) {
    if (diff.secs < 60) {
      return `vor ${diff.secs} Sekunden`;
    } else if (diff.secs < 3600) {
      const mins = Math.floor(diff.secs / 60);
      return `vor ${pluralize(mins, "Minute", "Minuten")}`;
    }
  } else {
    if (diff.secs > -60) {
      return `in ${-diff.secs} Sekunden`;
    } else if (diff.secs > -3600) {
      const mins = Math.floor(diff.secs / 60);
      return `in ${pluralize(mins, "Minute", "Minuten")}`;
    }
  }
  if (diff.days !== null) {
    return `${dayToString[diff.days]} um ${getTime(date)}`;
  } else {
    return `am ${pad2(date.getDate())}.${pad2(date.getMonth() + 1)}.${pad2(
      date.getFullYear(),
    )} um ${getTime(date)}`;
  }
};

const HumanTime = ({ date }) => {
  if (!(date instanceof Date)) date = new Date(date);
  const [diff, setDiff] = useState(date && (() => getDiff(date)));
  const secs = diff && diff.secs;
  useEffect(() => {
    if (!date) return undefined;
    const nextTickS = getNextTickSecs(secs);
    if (!nextTickS) return undefined;
    const timeoutId = setTimeout(
      () => setDiff(getDiff(date)),
      nextTickS * 1000,
    );
    return () => clearTimeout(timeoutId);
  }, [secs, date]);

  if (!date) return <span style={{ color: "red" }}>No date passed</span>;

  return <span title={date.toISOString()}>{getLabel(diff, date)}</span>;
};

export default HumanTime;
